import { setSpecificMessage, checkItemsAsync } from "valibot";
setSpecificMessage(
  checkItemsAsync,
  (issue) => `Élément invalide: reçu ${issue.received}`,
  "fr"
);